import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";

export default class FakturyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokazPopup: false
        };
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'FakturaContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'},{addressUrl: '/administracja/faktury', text: 'Faktury'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>

                        </Col>
                    </Row>
                </Grid>
                {
                    this.state.pokazPopup ?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                                <div>
                                    <div className={'pull-right'}>
                                        <TopButtonAction onClick={() => {
                                            this.setState({pokazPopup: false})
                                        }}
                                                         elementStyle={{color:'firebrick'}}
                                                         btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                        />
                                    </div>
                                    <div style={{clear: 'both'}}></div>
                                    <div id={'modalTextContent'}>
                                        modal
                                        <div style={{clear: 'both'}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ''

                }
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/faktury/components/FakturyContainer.js